import styled from "styled-components";

import { PrimaryButton } from "components/Button";
import { Section } from "containers/Section/styles";

export const HomePageCardSectionStyled = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
  background-position: center;
  background-size: cover;
  min-height: 332px;
`;

export const BannerSection = styled(Section)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: left;
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
`;

export const OverviewSection = styled(Section)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
`;

export const ProcessExpositionSection = styled(Section)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
`;

export const PaymentsOverviewSection = styled(Section)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
`;

export const FaqsSection = styled(Section)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
`;

export const OkBtn = styled(PrimaryButton)`
  width: 100%;
  background: ${({ theme }) => theme.customTheme.palette.black.black25};
`;
